// components/Loader.js
import React from 'react';
import logo from '../assets/images/chosenlogo2.png';  // Import your logo image
import './Loader.css'; // Optional for custom styles if needed

const Loader = () => {
    return (
        <div className="loader-container">
            <img src={logo} alt="Loading..." className="loader-image" />
        </div>
    );
};

export default Loader;
